module.exports = __webpack_public_path__ + "img/LTS_Namibia.a524047f.gif";